export const SITE_NAME = 'Alden Technologies';
export const TAGLINE = 'Turnkey Water, Beverage & Packaging Engineering Solutions';
export const SITE_URL = 'https://aldentechnologies.in';
export const PHONE_DISPLAY = '+91 93512 92512';
export const PHONE_TEL = '+919351292512';
export const PHONE2_DISPLAY = '+91 93510 02512';
export const PHONE2_TEL = '+919351002512';
export const WHATSAPP_NUMBER = '919351292512';
export const CONTACT_EMAIL = 'info@aldentechnologies.in';
export const CONTACT_EMAIL_ALT = 'aldentechnologiesindia@gmail.com';
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_turnkey-plants-1/artifacts/k3rh7ndp_ALDEN%20LOGO%20PNG.png';

export const getCanonical = (path) =>
  `${typeof window !== 'undefined' ? window.location.origin : SITE_URL}${path}`;
